// extracted by mini-css-extract-plugin
export default {"hide-text":"HideText__hide-text--ahfVd","hideText":"HideText__hide-text--ahfVd"};